module.exports = __webpack_public_path__ + "77e6c9ab31dd2d0fc9238fc1a2f14163-infra_hero_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/header/assets/infra_hero_2x.jpg
// module id = 571
// module chunks = 0